import { FilterToggle } from './filter-toggle';

interface GlobalFiltersProps {
  lowestPricesOnly: boolean;
  includeOutOfStock: boolean;
  onLowestPricesChange: (value: boolean) => void;
  onIncludeOutOfStockChange: (value: boolean) => void;
}

export function GlobalFilters({
  lowestPricesOnly,
  includeOutOfStock,
  onLowestPricesChange,
  onIncludeOutOfStockChange,
}: GlobalFiltersProps) {
  return (
    <div className="space-y-4 mb-4 mt-1">
      <FilterToggle
        id="show-only-lowest-prices"
        label="הצגת רק מוצרים במחיר הזול ביותר"
        checked={lowestPricesOnly}
        onCheckedChange={onLowestPricesChange}
      />

      <FilterToggle
        id="include-out-of-stock"
        label="הצגת מוצרים שאינם במלאי"
        checked={includeOutOfStock}
        onCheckedChange={onIncludeOutOfStockChange}
      />
    </div>
  );
}
